import React, { useContext, useEffect } from 'react';
import { StateContext } from 'context';
import './asociaciones-de-empleados.css';
import { Themes } from 'styles';
import { AsociacionesDeEmpleados1Img, AsociacionesDeEmpleados2Img } from 'assets/img';
const AsociacionesDeEmpleados = (props) => {
    const state = useContext(StateContext);
    const indexTema = state && state.appReducer && state.appReducer.indexTema ? state.appReducer.indexTema : 0;
    useEffect(() => {
        // console.log('Themes[indexTema].D1', Themes[indexTema].D1);
    }, []);

    return (
        <>
            <div id="asociaciones-de-empleados" className="w3-block">
                <div className="w3-content">
                    <div className="w3-row">
                        {/* <div className="w3-col l4 m4 w3-center w3-hide-small">
                            <img src={AsociacionesDeEmpleadosImg} alt="asociaciones-de-empleados-img"/>
                        </div> */}
                        <div className="w3-col l4 m12 col-imagenes">
                            <div className="w3-row">
                                <div className="w3-col l12 m6 s6">
                                    <div className="w3-block w3-center w3-padding bs-bbox">
                                        <div className="img-container background-cover w3-card"
                                            style={{ backgroundImage: `url(${AsociacionesDeEmpleados1Img})` }}>
                                        </div>
                                    </div>
                                </div>
                                <div className="w3-col l12 m6 s6">
                                    <div className="w3-block w3-center w3-padding bs-bbox">
                                        <div className="img-container background-cover w3-card"
                                            style={{ backgroundImage: `url(${AsociacionesDeEmpleados2Img})` }}>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w3-rest w3-padding">
                            <h1 style={{ color: Themes[indexTema].D1 }}>Asociaciones de empleados</h1>
                            <p>En SERFIN le damos la importancia que se merecen a las Asociaciones de Empleados que quieran obtener mejores beneficios para sus asociados. Por eso las asociaciones interesadas en obtener créditos personales agiles y con minimo requisitos para sus asociados, deberán pertenecer al portafolio de clientes preferenciales de la entidad y con ello acceder a los productos. </p>
                            <p>Contactanos al <a href="tel:+59521204365" rel="noreferrer">(595 21) 204 365</a> ó escríbenos a <a href="maito:info@serfin.com.py" rel="noreferrer">info@serfin.com.py</a> que un Asesor se comunicara para brindar más detalles.</p>
                            {/* <FormularioSolicitud/> */}
                        </div>
                    </div>
                    {/* <div className="w3-row w3-hide-medium w3-hide-large">
                        <div className="w3-col s12 w3-center">
                            <img src={AsociacionesDeEmpleadosImg} alt="asociaciones-de-empleados-img" style={{ width: '70%' }} />
                        </div>
                    </div> */}
                </div>
            </div>
        </>
    );
}
export default AsociacionesDeEmpleados;